import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext.tsx';
import bankService from "@bankService";

export function useFetchAllBanks() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['banks'],
    queryFn: async () => {
      return await bankService.fetchAllBanks();
    },
    enabled: !!user,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useCreateBank() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ name, address }: { name: string; address?: string }) => {
      return await bankService.createBank({ name, address });
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['banks'] }),
  });
}
